export type DeactivationReason = (typeof DEACTIVATION_REASONS)[keyof typeof DEACTIVATION_REASONS];
export type Step = (typeof STEPS)[keyof typeof STEPS];

export const DEACTIVATION_REASONS = {
  FOUND_TENANT: 'FOUND_TENANT',
  TENANT_RENEWED: 'TENANT_RENEWED',
  STILL_LOOKING_PAUSING: 'STILL_LOOKING_PAUSING',
} as const;

export const ANSWER_CARD_CONFIG = [
  {
    reason: DEACTIVATION_REASONS.FOUND_TENANT,
    title: 'I found a new tenant',
  },
  {
    reason: DEACTIVATION_REASONS.TENANT_RENEWED,
    title: 'My current tenant renewed',
  },
  {
    reason: DEACTIVATION_REASONS.STILL_LOOKING_PAUSING,
    title: 'I am still looking for a tenant but am pausing this Zillow listing',
  },
] as const;

export const STEPS = {
  DEACTIVATION_REASON: 'deactivationReason',
} as const;
